import { FILE_LOAD_STATUS } from '../reducers/types';
import { createAction } from './common';

export const setFileLoadStart = createAction(
  FILE_LOAD_STATUS.SET_FILE_LOAD_START
);
export const setFileLoadEnd = createAction(FILE_LOAD_STATUS.SET_FILE_LOAD_END);
